import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from '@abroad/components'
import { getRecurringPatternOptions } from './recurringPatternOptions'

const ScheduleSettingsModal = ({
  show = false,
  handleClose = () => {},
  onConfirm = () => {},
  selectedDate = null,
  coachDetails = null,
}) => {
  const [selectedPattern, setSelectedPattern] = useState('')

  useEffect(() => {
    if (!show) {
      setSelectedPattern('')
    }
  }, [show])

  const patternOptions = getRecurringPatternOptions(coachDetails, selectedDate)

  const handleConfirm = () => {
    if (!selectedPattern) {
      return
    }
    onConfirm(selectedPattern)
    handleClose()
  }

  const handleCloseModal = () => {
    setSelectedPattern('')
    handleClose()
  }

  return (
    <Modal
      show={show}
      onHide={handleCloseModal}
      centered
      size='lg'
      className='payment-modal'
      dialogClassName='payment-modal-dialog justify-content-center'>
      <Modal.Header className='payment-modal-header d-flex justify-content-center'>
        <h3 className='payment-modal-title mb-0 text-uppercase'>
          Schedule Settings
        </h3>
      </Modal.Header>
      <Modal.Body className='payment-modal-body'>
        <div className='mb-3'>
          <div className='s10c mb-2'>RECURRING SESSIONS</div>
          <select
            className='form-select s8'
            value={selectedPattern}
            onChange={(e) => setSelectedPattern(e.target.value)}>
            <option value=''>Select</option>
            {patternOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </Modal.Body>
      <Modal.Footer className='border-0 d-flex justify-content-end gap-3 flex-row'>
        <Button
          variant='secondary-light'
          className='px-4 text-uppercase secondary-popup-button'
          size='sm'
          onClick={handleCloseModal}>
          CLOSE
        </Button>
        <Button
          variant='saffron'
          className='px-4 text-uppercase'
          size='sm'
          onClick={handleConfirm}
          disabled={!selectedPattern}>
          CONFIRM
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ScheduleSettingsModal
